import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Cookies from 'js-cookie';
import { fg } from '@atlaskit/platform-feature-flags';
import { sendPackageOperationalEvent } from '../../../common/utils';
import { loadStorageControlsData } from '../../../common/utils/load-storage-controls-data';
import { Logger } from '../../../common/utils/logger';
import { PreferenceCategory } from '../../../types';
import { getPreferences } from '../../storage-preferences/get-preferences';
import { Status } from './types';
var findStartsWithPatternMatch = function findStartsWithPatternMatch(cookieName, _ref) {
  var startsWith = _ref.startsWith;
  // Setup initial pattern step and position
  var currentStep = startsWith;
  var position = 0;

  // Iterate through cookie name symbol by symbol
  while (position < cookieName.length) {
    // The value of cookie character at the position
    var currentStepValue = currentStep[cookieName[position]];
    // If there is no match for cookie symbol in cache, this means there is no
    // pattern match for the cookie name
    if (currentStepValue === undefined) {
      return null;
    }
    // If current step value is a number, this means we reached the end of the pattern
    // and should return category number
    if (typeof currentStepValue === 'number') {
      return currentStepValue;
    }
    // Continue to going through pattern
    currentStep = currentStepValue;
    position++;
  }

  // No pattern match - all patterns longer or shorter than cookie name
  return null;
};
var getPreferenceCategory = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cookieName) {
    var storageControlsData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return loadStorageControlsData();
        case 2:
          storageControlsData = _context.sent;
          if (storageControlsData) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", null);
        case 7:
          return _context.abrupt("return", getPreferenceCategoryFromPassedCache(cookieName, storageControlsData));
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getPreferenceCategory(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Synchronously fetches a cookie category from a CategorizedCookiesCache that has already been fetched
 *
 * This allows synchronous parts of the code to access cached versions of the cache but still maintain
 * a synchronous signature for clients
 *
 */
export var getPreferenceCategoryFromPassedCache = function getPreferenceCategoryFromPassedCache(cookieName, storageControlsData) {
  var _numToCategoryMap;
  var cookieCategoryNumber = null;
  var keys = storageControlsData.keys,
    categories = storageControlsData.categories,
    patterns = storageControlsData.patterns;
  // Find direct match in keys
  if (cookieName in Object(keys)) {
    cookieCategoryNumber = keys[cookieName];
  } else {
    // Find pattern match or null
    cookieCategoryNumber = findStartsWithPatternMatch(cookieName, patterns);
  }
  var numToCategoryMap = (_numToCategoryMap = {}, _defineProperty(_numToCategoryMap, categories.STRICTLY_NECESSARY, PreferenceCategory.StrictlyNecessary), _defineProperty(_numToCategoryMap, categories.FUNCTIONAL, PreferenceCategory.Functional), _defineProperty(_numToCategoryMap, categories.ANALYTICS, PreferenceCategory.Analytics), _defineProperty(_numToCategoryMap, categories.MARKETING, PreferenceCategory.Marketing), _defineProperty(_numToCategoryMap, categories.UNKNOWN, PreferenceCategory.Unknown), _numToCategoryMap);
  return cookieCategoryNumber !== null ? numToCategoryMap[cookieCategoryNumber] : null;
};

/**
 * Given a cookie key, fetches preferences and categories and determines whether the cookie can be set
 *
 * Allows an optional allowedCallback to be passed which is invoked in the case the cookie is allowed to be set.
 * This allows synchronous parts of the code to check a cookie's status (e.g. the document.cookie set override)
 *
 */
export var canSetCookie = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var cookieKey, _ref3$allowedCallback, allowedCallback, _ref3$blockedCallback, blockedCallback, shouldSetCookie, cookieCategory, preferences, hasPreferencesForCategory;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          cookieKey = _ref3.cookieKey, _ref3$allowedCallback = _ref3.allowedCallback, allowedCallback = _ref3$allowedCallback === void 0 ? function () {} : _ref3$allowedCallback, _ref3$blockedCallback = _ref3.blockedCallback, blockedCallback = _ref3$blockedCallback === void 0 ? function () {} : _ref3$blockedCallback;
          _context2.next = 3;
          return getPreferenceCategory(cookieKey);
        case 3:
          cookieCategory = _context2.sent;
          if (!(cookieCategory === PreferenceCategory.StrictlyNecessary)) {
            _context2.next = 8;
            break;
          }
          shouldSetCookie = true;
          _context2.next = 14;
          break;
        case 8:
          _context2.next = 10;
          return getPreferences();
        case 10:
          preferences = _context2.sent;
          hasPreferencesForCategory = false;
          if (!!preferences) {
            if (!!cookieCategory) {
              hasPreferencesForCategory = preferences[cookieCategory];
            }
          }
          shouldSetCookie = hasPreferencesForCategory;
        case 14:
          if (shouldSetCookie) {
            allowedCallback === null || allowedCallback === void 0 || allowedCallback();
          } else {
            blockedCallback === null || blockedCallback === void 0 || blockedCallback({
              cookieHasCategory: cookieCategory != null
            });
          }
          return _context2.abrupt("return", shouldSetCookie);
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function canSetCookie(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Sets a cookie asynchronously. This queries user preferences before setting
 * the cookie, so it must be used for any cookies which are not strictly
 * necessary.
 */
export var setCookie = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, value, attributes) {
    var _eventAttributes, shouldSetCookie, eventAttributes;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (fg('platform.moonjelly.browser-storage-controls')) {
            _context3.next = 11;
            break;
          }
          _eventAttributes = {
            wasRejected: false,
            cookieKey: key
          };
          _context3.prev = 2;
          Cookies.set(key, value, attributes);
          return _context3.abrupt("return", Status.SUCCESS);
        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](2);
          Logger.errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: _eventAttributes,
            message: "Failed to use set cookie. ".concat(_context3.t0.message || '')
          });
          return _context3.abrupt("return", Status.FAILED);
        case 11:
          _context3.next = 13;
          return canSetCookie({
            cookieKey: key
          });
        case 13:
          shouldSetCookie = _context3.sent;
          eventAttributes = {
            wasRejected: !shouldSetCookie,
            cookieKey: key
          };
          _context3.prev = 15;
          sendPackageOperationalEvent({
            action: 'usedSetCookie',
            attributes: eventAttributes
          });
          if (!shouldSetCookie) {
            _context3.next = 22;
            break;
          }
          Cookies.set(key, value, _objectSpread(_objectSpread({}, attributes), {}, {
            'atl-set-cookie': true
          }));
          return _context3.abrupt("return", Status.SUCCESS);
        case 22:
          return _context3.abrupt("return", Status.BLOCKED);
        case 23:
          _context3.next = 29;
          break;
        case 25:
          _context3.prev = 25;
          _context3.t1 = _context3["catch"](15);
          Logger.errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: eventAttributes,
            message: "Failed to use set cookie. ".concat(_context3.t1.message || '')
          });
          return _context3.abrupt("return", Status.BLOCKED);
        case 29:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 7], [15, 25]]);
  }));
  return function setCookie(_x3, _x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}();